import React from 'react';
import TopicForm from '../../../components/forms/TopicForm';

export default function TopicsCreatePage() {
  return <TopicForm />;
}
